import { render } from "./GDQQuestionnaire.vue?vue&type=template&id=6dab4e65"
import script from "./GDQQuestionnaire.vue?vue&type=script&lang=js"
export * from "./GDQQuestionnaire.vue?vue&type=script&lang=js"

import "./GDQQuestionnaire.vue?vue&type=style&index=0&id=6dab4e65&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__